import React from "react";

import DetailModal from "../ui/DetailModal";
import { Button } from "../ui";
import FormSale from "../forms/FormSale";

const SaleFormModal = ({ open, setOpen, handleClose, setShowModal }) => {
    const handleBack = () => {
        setShowModal(true);
        setOpen(false);
    };

    return (
        <DetailModal
            open={open}
            onClose={handleClose}
            title="New Sale"
            size="xl"
            actions={
                <>
                    <Button variant="secondary" size="sm" onClick={handleBack}>
                        Back
                    </Button>
                    <Button variant="primary" size="sm" type="submit" form="sale-form">
                        Add Sale
                    </Button>
                </>
            }
        >
            <FormSale handleClose={handleClose} />
        </DetailModal>
    );
};

export default SaleFormModal;
